export default __webpack_public_path__ + "static/media/wc.f837a1c7.svg";